<template>
  <ScrollUp :type="ctaVariant"/>
  <div class="etx-container Container pt-50 pb-50">
    <div class="etx-center Center">
      <div class="etx-flex Flex gv-150 tab-m:gv-0 av-bottom">
        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-8 tab-l:c-7">
          <div class="Breadcrumb" :class="entranceClassList">
            <NuxtPageDependency>
              <Breadcrumb :links="breadcrumb" />
            </NuxtPageDependency>
          </div>
          <div class="etx-text Text" :class="entranceClassList">
            <h1>{{ title }}</h1>
            <p v-if="subtitle" class="font-h1 alt">{{ subtitle }}</p>
          </div>
        </div>
        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-3 tab-l:c-4 tab-m:ml-1">
          <div v-if="tags" v-for="tag in tags" class="TagList tab-m:a-right" :class="entranceClassList">
            <div class="Tag">{{ tag.name }}</div>
          </div>
          <div class="etx-text Text tab-m:a-right" :class="entranceClassList">
            <p v-if="formattedVisibleDate">{{ formattedVisibleDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="etx-container Container pt-0">
    <div class="etx-center Center">
      <div class="etx-flex Flex gv-150 tab-l:gv-0 tab-l:av-stretch">
        <div class="etx-flex__item Flex__item tab-l:c-7 desk-s:c-8">
          <div class="FixedRatio ratio-3-2" :class="entranceClassList">
            <div class="etx-background-media BackgroundMedia" :class="backgroundMediaClassList">
              <div class="etx-media Media">
                <div class="etx-media Media">
                  <MediaImage :media="image" imageStyle="image_3_2" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-5 desk-s:c-4">
          <div class="etx-card Card">
            <div class="etx-card__item Card__item ph-0 pv-0 tab-m:pt-200"></div>
            <div v-if="lead || sublead" class="etx-card__item Card__item ph-0 tab-l:pl-150 pv-0">
              <div class="etx-text Text" :class="entranceClassList">
                <p v-if="lead" class="font-size-large font-weight-bold font-color-primary">{{ lead }}</p>
                <p v-if="sublead">{{ sublead }}</p>
                <p v-if="readingduration" class="font-size-small font-color-medium">{{ readingduration }}</p>
              </div>
            </div>
            <div class="etx-card__item Card__item ph-0 pv-0 grow-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <BlokkliField :list="paragraphs" name="field_paragraphs" />
  </BlokkliProvider>

</template>

<script lang="ts" setup>
import type { NodeNewsFragment } from '#graphql-operations'

const breadcrumb = useBreadcrumbLinks()

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day} / ${month} / ${year}`;
};

const formattedVisibleDate = computed(() => {
  const dateValue = props.visibledate?.value;
  return formatDate(dateValue);
});

const props = defineProps<{
  uuid: string
  title?: string
  subtitle?: string
  lead?: string
  sublead?: string
  readingduration?: string
  publication?: string
  depublication?: string
  visibledate?: Object
  tags?: Array<Object>
  image?: Object
  paragraphs?: NodeNewsFragment['paragraphs']
  blokkliProps: NodeNewsFragment['blokkliProps']
  verticalAlign: string
  isFrontpage?: boolean
  ctaVariant?: string
}>()

if (props?.isFrontpage) {
  useHead({
    htmlAttrs: {
      class: 'home',
    },
  });
}

const entranceClassList = computed(() => {
  const classList = []
  classList.push('will-appear', 'move-up')
  return classList
})

const backgroundMediaClassList = computed(() => {

  if (props?.verticalAlign && props?.verticalAlign != 'center') {
    return props?.verticalAlign
  }

  if (props?.image?.verticalAlign && props?.image?.verticalAlign != 'center') {
    return props?.image?.verticalAlign
  }

  return ''
})

</script>
